import { Directive, ElementRef, Input } from '@angular/core';
import { GroupedSection } from '@miq/catalog';
import { columnNotFavoriteNotRequired } from './not-favorite-not-required';
import { VisibilityToggler } from './visibility-toggler';

@Directive({
  selector: '[miqShowFavoriteGroupSection]',
  standalone: false,
})
export class ShowFavoriteGroupSectionDirective extends VisibilityToggler<GroupedSection> {
  @Input('miqShowFavoriteGroupSection') declare input: GroupedSection;

  constructor(protected el: ElementRef) {
    super(el);
  }

  shouldHide(favorites: { [key: number]: boolean }): boolean {
    return this.input.sections.every(
      section =>
        // no template
        !section.templateRefName &&
        // no favorite and not required
        section.columns.every(col => columnNotFavoriteNotRequired(favorites, col))
    );
  }
}
